/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * AGOS API
 * v1 is a faithful port of the HellKitchen Express API: same paths under /api/v1, same request and response shapes, same status codes and error messages.
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type {
  UpsellCopied,
  UpsellCopyRequest,
  UpsellGroup,
  UpsellGroupRequest,
  UpsellGroupsOrderRequest,
  UpsellItem,
  UpsellItemsOrderRequest,
  UpsellLinksRequest,
} from '../../model'

import { customFetch } from '../../../custom-fetch'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

export const getPutUpsellItemsAddonProductIdLinksUrl = (addonProductId: number) => {
  return `/api/v1/upsell/items/${addonProductId}/links`
}

/**
 * @summary Replace the products an add-on is offered with, in one group or none
 */
export const putUpsellItemsAddonProductIdLinks = async (
  addonProductId: number,
  upsellLinksRequest: UpsellLinksRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<UpsellItem> => {
  return customFetch<UpsellItem>(getPutUpsellItemsAddonProductIdLinksUrl(addonProductId), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(upsellLinksRequest),
  })
}

export const getPutUpsellItemsAddonProductIdLinksMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putUpsellItemsAddonProductIdLinks>>,
    TError,
    { addonProductId: number; data: UpsellLinksRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putUpsellItemsAddonProductIdLinks>>,
  TError,
  { addonProductId: number; data: UpsellLinksRequest },
  TContext
> => {
  const mutationKey = ['putUpsellItemsAddonProductIdLinks']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putUpsellItemsAddonProductIdLinks>>,
    { addonProductId: number; data: UpsellLinksRequest }
  > = (props) => {
    const { addonProductId, data } = props ?? {}

    return putUpsellItemsAddonProductIdLinks(addonProductId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutUpsellItemsAddonProductIdLinksMutationResult = NonNullable<
  Awaited<ReturnType<typeof putUpsellItemsAddonProductIdLinks>>
>
export type PutUpsellItemsAddonProductIdLinksMutationBody = UpsellLinksRequest
export type PutUpsellItemsAddonProductIdLinksMutationError = unknown

/**
 * @summary Replace the products an add-on is offered with, in one group or none
 */
export const usePutUpsellItemsAddonProductIdLinks = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putUpsellItemsAddonProductIdLinks>>,
      TError,
      { addonProductId: number; data: UpsellLinksRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putUpsellItemsAddonProductIdLinks>>,
  TError,
  { addonProductId: number; data: UpsellLinksRequest },
  TContext
> => {
  return useMutation(getPutUpsellItemsAddonProductIdLinksMutationOptions(options), queryClient)
}
export const getPutUpsellItemsOrderUrl = () => {
  return `/api/v1/upsell/items/order`
}

/**
 * @summary Set the order the add-ons are offered in
 */
export const putUpsellItemsOrder = async (
  upsellItemsOrderRequest: UpsellItemsOrderRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<UpsellItem[]> => {
  return customFetch<UpsellItem[]>(getPutUpsellItemsOrderUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(upsellItemsOrderRequest),
  })
}

export const getPutUpsellItemsOrderMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putUpsellItemsOrder>>,
    TError,
    { data: UpsellItemsOrderRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putUpsellItemsOrder>>,
  TError,
  { data: UpsellItemsOrderRequest },
  TContext
> => {
  const mutationKey = ['putUpsellItemsOrder']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putUpsellItemsOrder>>,
    { data: UpsellItemsOrderRequest }
  > = (props) => {
    const { data } = props ?? {}

    return putUpsellItemsOrder(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutUpsellItemsOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof putUpsellItemsOrder>>
>
export type PutUpsellItemsOrderMutationBody = UpsellItemsOrderRequest
export type PutUpsellItemsOrderMutationError = unknown

/**
 * @summary Set the order the add-ons are offered in
 */
export const usePutUpsellItemsOrder = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putUpsellItemsOrder>>,
      TError,
      { data: UpsellItemsOrderRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putUpsellItemsOrder>>,
  TError,
  { data: UpsellItemsOrderRequest },
  TContext
> => {
  return useMutation(getPutUpsellItemsOrderMutationOptions(options), queryClient)
}
export const getPutUpsellGroupsOrderUrl = () => {
  return `/api/v1/upsell/groups/order`
}

/**
 * @summary Set the order of the upsell groups
 */
export const putUpsellGroupsOrder = async (
  upsellGroupsOrderRequest: UpsellGroupsOrderRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<UpsellGroup[]> => {
  return customFetch<UpsellGroup[]>(getPutUpsellGroupsOrderUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(upsellGroupsOrderRequest),
  })
}

export const getPutUpsellGroupsOrderMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putUpsellGroupsOrder>>,
    TError,
    { data: UpsellGroupsOrderRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putUpsellGroupsOrder>>,
  TError,
  { data: UpsellGroupsOrderRequest },
  TContext
> => {
  const mutationKey = ['putUpsellGroupsOrder']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putUpsellGroupsOrder>>,
    { data: UpsellGroupsOrderRequest }
  > = (props) => {
    const { data } = props ?? {}

    return putUpsellGroupsOrder(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutUpsellGroupsOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof putUpsellGroupsOrder>>
>
export type PutUpsellGroupsOrderMutationBody = UpsellGroupsOrderRequest
export type PutUpsellGroupsOrderMutationError = unknown

/**
 * @summary Set the order of the upsell groups
 */
export const usePutUpsellGroupsOrder = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putUpsellGroupsOrder>>,
      TError,
      { data: UpsellGroupsOrderRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putUpsellGroupsOrder>>,
  TError,
  { data: UpsellGroupsOrderRequest },
  TContext
> => {
  return useMutation(getPutUpsellGroupsOrderMutationOptions(options), queryClient)
}
export const getGetUpsellGroupsUrl = () => {
  return `/api/v1/upsell/groups`
}

/**
 * @summary List the upsell groups, in prompt order
 */
export const getUpsellGroups = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<UpsellGroup[]> => {
  return customFetch<UpsellGroup[]>(getGetUpsellGroupsUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetUpsellGroupsQueryKey = () => {
  return [`/api/v1/upsell/groups`] as const
}

export const getGetUpsellGroupsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUpsellGroups>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpsellGroups>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetUpsellGroupsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUpsellGroups>>> = ({ signal }) =>
    getUpsellGroups({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUpsellGroups>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUpsellGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getUpsellGroups>>>
export type GetUpsellGroupsQueryError = unknown

export function useGetUpsellGroups<
  TData = Awaited<ReturnType<typeof getUpsellGroups>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpsellGroups>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpsellGroups>>,
          TError,
          Awaited<ReturnType<typeof getUpsellGroups>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUpsellGroups<
  TData = Awaited<ReturnType<typeof getUpsellGroups>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpsellGroups>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpsellGroups>>,
          TError,
          Awaited<ReturnType<typeof getUpsellGroups>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUpsellGroups<
  TData = Awaited<ReturnType<typeof getUpsellGroups>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpsellGroups>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the upsell groups, in prompt order
 */

export function useGetUpsellGroups<
  TData = Awaited<ReturnType<typeof getUpsellGroups>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpsellGroups>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetUpsellGroupsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostUpsellGroupsUrl = () => {
  return `/api/v1/upsell/groups`
}

/**
 * @summary Create an upsell group
 */
export const postUpsellGroups = async (
  upsellGroupRequest: UpsellGroupRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<UpsellGroup> => {
  return customFetch<UpsellGroup>(getPostUpsellGroupsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(upsellGroupRequest),
  })
}

export const getPostUpsellGroupsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUpsellGroups>>,
    TError,
    { data: UpsellGroupRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postUpsellGroups>>,
  TError,
  { data: UpsellGroupRequest },
  TContext
> => {
  const mutationKey = ['postUpsellGroups']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postUpsellGroups>>,
    { data: UpsellGroupRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postUpsellGroups(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostUpsellGroupsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postUpsellGroups>>
>
export type PostUpsellGroupsMutationBody = UpsellGroupRequest
export type PostUpsellGroupsMutationError = unknown

/**
 * @summary Create an upsell group
 */
export const usePostUpsellGroups = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postUpsellGroups>>,
      TError,
      { data: UpsellGroupRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postUpsellGroups>>,
  TError,
  { data: UpsellGroupRequest },
  TContext
> => {
  return useMutation(getPostUpsellGroupsMutationOptions(options), queryClient)
}
export const getPostUpsellCopyUrl = () => {
  return `/api/v1/upsell/copy`
}

/**
 * @summary Copy one product's add-ons onto many
 */
export const postUpsellCopy = async (
  upsellCopyRequest: UpsellCopyRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<UpsellCopied> => {
  return customFetch<UpsellCopied>(getPostUpsellCopyUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(upsellCopyRequest),
  })
}

export const getPostUpsellCopyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUpsellCopy>>,
    TError,
    { data: UpsellCopyRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postUpsellCopy>>,
  TError,
  { data: UpsellCopyRequest },
  TContext
> => {
  const mutationKey = ['postUpsellCopy']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postUpsellCopy>>,
    { data: UpsellCopyRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postUpsellCopy(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostUpsellCopyMutationResult = NonNullable<Awaited<ReturnType<typeof postUpsellCopy>>>
export type PostUpsellCopyMutationBody = UpsellCopyRequest
export type PostUpsellCopyMutationError = unknown

/**
 * @summary Copy one product's add-ons onto many
 */
export const usePostUpsellCopy = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postUpsellCopy>>,
      TError,
      { data: UpsellCopyRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postUpsellCopy>>,
  TError,
  { data: UpsellCopyRequest },
  TContext
> => {
  return useMutation(getPostUpsellCopyMutationOptions(options), queryClient)
}
export const getDeleteUpsellGroupsGroupIdUrl = (groupId: number) => {
  return `/api/v1/upsell/groups/${groupId}`
}

/**
 * @summary Delete an upsell group, detaching its links
 */
export const deleteUpsellGroupsGroupId = async (
  groupId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteUpsellGroupsGroupIdUrl(groupId), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteUpsellGroupsGroupIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUpsellGroupsGroupId>>,
    TError,
    { groupId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteUpsellGroupsGroupId>>,
  TError,
  { groupId: number },
  TContext
> => {
  const mutationKey = ['deleteUpsellGroupsGroupId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteUpsellGroupsGroupId>>,
    { groupId: number }
  > = (props) => {
    const { groupId } = props ?? {}

    return deleteUpsellGroupsGroupId(groupId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteUpsellGroupsGroupIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteUpsellGroupsGroupId>>
>

export type DeleteUpsellGroupsGroupIdMutationError = unknown

/**
 * @summary Delete an upsell group, detaching its links
 */
export const useDeleteUpsellGroupsGroupId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteUpsellGroupsGroupId>>,
      TError,
      { groupId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteUpsellGroupsGroupId>>,
  TError,
  { groupId: number },
  TContext
> => {
  return useMutation(getDeleteUpsellGroupsGroupIdMutationOptions(options), queryClient)
}
export const getPatchUpsellGroupsGroupIdUrl = (groupId: number) => {
  return `/api/v1/upsell/groups/${groupId}`
}

/**
 * @summary Change an upsell group
 */
export const patchUpsellGroupsGroupId = async (
  groupId: number,
  upsellGroupRequest: UpsellGroupRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<UpsellGroup> => {
  return customFetch<UpsellGroup>(getPatchUpsellGroupsGroupIdUrl(groupId), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(upsellGroupRequest),
  })
}

export const getPatchUpsellGroupsGroupIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchUpsellGroupsGroupId>>,
    TError,
    { groupId: number; data: UpsellGroupRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchUpsellGroupsGroupId>>,
  TError,
  { groupId: number; data: UpsellGroupRequest },
  TContext
> => {
  const mutationKey = ['patchUpsellGroupsGroupId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchUpsellGroupsGroupId>>,
    { groupId: number; data: UpsellGroupRequest }
  > = (props) => {
    const { groupId, data } = props ?? {}

    return patchUpsellGroupsGroupId(groupId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchUpsellGroupsGroupIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchUpsellGroupsGroupId>>
>
export type PatchUpsellGroupsGroupIdMutationBody = UpsellGroupRequest
export type PatchUpsellGroupsGroupIdMutationError = unknown

/**
 * @summary Change an upsell group
 */
export const usePatchUpsellGroupsGroupId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchUpsellGroupsGroupId>>,
      TError,
      { groupId: number; data: UpsellGroupRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchUpsellGroupsGroupId>>,
  TError,
  { groupId: number; data: UpsellGroupRequest },
  TContext
> => {
  return useMutation(getPatchUpsellGroupsGroupIdMutationOptions(options), queryClient)
}
export const getGetUpsellItemsUrl = () => {
  return `/api/v1/upsell/items`
}

/**
 * @summary List every add-on with the products it is offered with
 */
export const getUpsellItems = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<UpsellItem[]> => {
  return customFetch<UpsellItem[]>(getGetUpsellItemsUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetUpsellItemsQueryKey = () => {
  return [`/api/v1/upsell/items`] as const
}

export const getGetUpsellItemsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUpsellItems>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpsellItems>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetUpsellItemsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUpsellItems>>> = ({ signal }) =>
    getUpsellItems({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUpsellItems>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUpsellItemsQueryResult = NonNullable<Awaited<ReturnType<typeof getUpsellItems>>>
export type GetUpsellItemsQueryError = unknown

export function useGetUpsellItems<
  TData = Awaited<ReturnType<typeof getUpsellItems>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpsellItems>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpsellItems>>,
          TError,
          Awaited<ReturnType<typeof getUpsellItems>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUpsellItems<
  TData = Awaited<ReturnType<typeof getUpsellItems>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpsellItems>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpsellItems>>,
          TError,
          Awaited<ReturnType<typeof getUpsellItems>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUpsellItems<
  TData = Awaited<ReturnType<typeof getUpsellItems>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpsellItems>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List every add-on with the products it is offered with
 */

export function useGetUpsellItems<
  TData = Awaited<ReturnType<typeof getUpsellItems>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpsellItems>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetUpsellItemsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}
